import { IconInvisible } from "@/components/_icons/IconInvisible";
import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { useMunicipalPropertySections } from "@/domain/municipal-property/hooks/use-municipal-property-sections";
import { MUNICIPAL_PROPERTY_SEGMENT } from "@/domain/municipal-property/routes/municipal-property-base-path";
import { makeWorkspaceSettingsUrl } from "@/domain/workspace/lib/make-workspace-url";
import { Workspace } from "@/domain/workspace/models/workspace-model";

export const MunicipalPropertySidebarNavLink = ({ workspace }: { workspace: Workspace }) => {
  const { t } = useDomainTranslation("common");

  const { defaultSectionPath } = useMunicipalPropertySections();
  if (!defaultSectionPath) return null;

  return (
    <SidebarNavElement to={makeWorkspaceSettingsUrl({ workspace, path: MUNICIPAL_PROPERTY_SEGMENT })}>
      <IconInvisible className="mr-2 h-3 w-3" />
      {t("navigation.municipalProperties")}
    </SidebarNavElement>
  );
};
